// extracted by mini-css-extract-plugin
export default {"grid":"Home_grid__QD-ZJ","scroll":"Home_scroll__-7pyl"};